import React, { useEffect, useState } from 'react';
import ProjectsCard from './ProjectsCard';
import WebPreviewDataServices from '../../services/FirebaseServices'

const Projects = () => {
    const [data, setData] = useState([])
    useEffect(() => {
        getAllWebPreview();
    }, [])

    const getAllWebPreview = async () => {
        const response = await WebPreviewDataServices.getAllWebPreview();
        setData(response.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    return (
        <div className="" id="projects" style={{marginBottom:'8rem'}}>
            <h1 className="projects-heading my-4 p-4 text-white text-center">MY PROJECTS</h1>
            <div className="container projects-container mt-3 mt-md-5 mx-auto d-flex justify-content-center text-center">
                <div className="row justify-content-between mx-auto">
                    {
                        data.length && data
                        .sort((a, b) => a.sort - b.sort)
                        .map((item, id) =>(
                                <ProjectsCard key={id} data={item}/>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};
export default Projects;